var map = {
	"./background.png": 40,
	"./bike-itau.png": 41,
	"./connect4.png": 42,
	"./firebase.png": 43,
	"./github.svg": 17,
	"./invaders.png": 44,
	"./javascript.png": 45,
	"./link-navi-bg.png": 16,
	"./link-navi.png": 46,
	"./linkedin.svg": 18,
	"./log-ai.png": 47,
	"./minichat.png": 48,
	"./next.png": 49,
	"./python.png": 50,
	"./react.png": 51,
	"./redux.png": 52,
	"./typescript.png": 53,
	"./whatsapp.svg": 19
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;